'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { isUnderMaintenanceClient } from '@/lib/maintenance';

/**
 * Client-side safety net: if a user changes the URL (or soft-navigates) while
 * maintenance is on, send them back to `/` before any page can mount and fetch.
 */
export function MaintenanceRouteGuard() {
    const pathname = usePathname();
    const router = useRouter();

    useEffect(() => {
        if (!isUnderMaintenanceClient()) return;
        if (pathname === '/') return;
        router.replace('/');
    }, [pathname, router]);

    return null;
}
